import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Admin_Parivartan_Create_Branch,
  Admin_Parivartan_Get_All_Branches,
  Admin_Region_Name,
  Admin_Regions_API,
} from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const RoBoModal = ({ open, onClose, onRefresh }) => {
  const [form, setForm] = useState({
    BranchName: "",
    RegionId: "",
    Zone: "",
    ro: "",
  });
  const [branchList, setBranchList] = useState([]);
  const [regionList, setRegionList] = useState([]);

  const fetchBranch = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_All_Branches}`);
      setBranchList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  const fetchRegion = async () => {
    try {
      const response = await axios.get(`${Admin_Region_Name}`);
      setRegionList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    fetchBranch();
    fetchRegion();
  }, [open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      Branch: form.BranchName,
      RegionId: form.RegionId,
      Zone: form.Zone,
      RO: form.ro,
    };

    try {
      const res = await axios.post(Admin_Parivartan_Create_Branch, payload);
      if (res.data.success) {
        toast.success("Region Created Successfully.");
        onRefresh();
        onClose();
        handleReset();
      } else {
        toast.error(res.data.message || "Failed to create region");
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const handleReset = () => {
    setForm({
      BranchName: "",
      RegionId: "",
      Zone: "",
      ro: "",
    });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New RO/BO
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <FormControl fullWidth>
              <TextField
                label="Branch Name"
                value={form.BranchName}
                onChange={(e) => handleChange("BranchName", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="branch-label">Region Name</InputLabel>
              <Select
                labelId="branch-label"
                label="Region Name"
                value={form.RegionId}
                onChange={(e) => handleChange("RegionId", e.target.value)}
                size="small"
              >
                <MenuItem value="">
                  <em>Select Region</em>
                </MenuItem>
                {regionList.map((st) => (
                  <MenuItem key={st.RegionId} value={st.RegionId}>
                    {st.RegionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Zone"
                value={form.Zone}
                onChange={(e) => handleChange("Zone", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="RO Name"
                value={form.ro}
                onChange={(e) => handleChange("ro", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RoBoModal;
